import type { StepType } from "@reactour/tour";
import { text } from "@quickpoint.me/shared";
import TourStepContent from "../../wrapper";
import { fireClearCodeEvent } from "../../../editor/events";
import { typeSomeText } from "../../common";

const actionTexts = [
	"This is a link",
	"This is a {{link}}",
	"\n  url: quickpoint.me",
	"This is a {{backlink}}\n  backlink: ",
];

const links: StepType[] = [
	{
		selector: "window",
		position: "center",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.linksTitle}</strong>} />
		),
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: actionTexts[0] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent description={() => text.tourSteps.linksAddLink} />
		),
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: actionTexts[1] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.linksUrlPrefix}{" "}
						<span className="qp-tour-modifier">url:</span> {text.tourSteps.linksUrlSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			typeSomeText({ text: actionTexts[2] });
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.linksBacklinkPrefix}{" "}
						<span className="qp-tour-modifier">backlink:</span>.
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			typeSomeText({ text: actionTexts[3], openAutoComplete: true });
		},
	},
];

export default links;
